import { itiMessageService, itiPermissionService, itiTokenService } from '@/iti-core-vue';
import templatesModule from '@/store/modules/templates.module';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { validate, ValidationProvider } from 'vee-validate';
import { Field } from '@/shared/dtos/field';
import { ItiIconButton, ItiVHeader } from '@/iti-core-vuetify';
import DxSelectBox from 'devextreme-vue/select-box';
import DxTextBox from 'devextreme-vue/text-box';
import DxNumberBox from 'devextreme-vue/number-box';
import DxTextArea from 'devextreme-vue/text-area';
import DxButton from 'devextreme-vue/button';
import DxDropDownBox from 'devextreme-vue/drop-down-box';
import DxTreeView from 'devextreme-vue/tree-view';
import DxCheckBox from 'devextreme-vue/check-box';
import { DxDataGrid, DxSelection, DxPaging, DxFilterRow, DxScrolling } from 'devextreme-vue/data-grid';
import DxValidationSummary from 'devextreme-vue/validation-summary';
import {
    DxValidator,
    DxRequiredRule,
    DxCompareRule,
    DxStringLengthRule,
} from 'devextreme-vue/validator';
import { FormattedCategory } from '@/shared/dtos/formatted-category';
import { Categories } from '@/shared/dtos/categories';
import { Permission } from '@/shared/permissions';

@Component({
    components: {
        ValidationProvider,
        ItiIconButton,
        DxSelectBox,
        DxTextBox,
        DxNumberBox,
        DxTextArea,
        DxButton,
        DxValidator,
        DxRequiredRule,
        DxCompareRule,
        DxStringLengthRule,
        DxValidationSummary,
        DxDropDownBox,
        DxTreeView,
        DxCheckBox,
        DxDataGrid,
        DxSelection,
        DxPaging,
        DxFilterRow,
        DxScrolling
    },
})

export default class PlantillaFormulario extends Vue {
    @Prop() id !: number;
    public loading = false;
    public search = "";
    public treeBoxValue: any = null;
    public beforeTreeBoxValue: any = null;
    public treeViewName = 'tree-view';
    public selectedCategory = new FormattedCategory();
    public categoriesDescription = "";
    public offerOrDemand = "";



    public get headers() {
        return [
            new ItiVHeader('code', 'plantillas.fieldCode'),
            new ItiVHeader('label', 'plantillas.fieldLabel'),
            new ItiVHeader('fieldType.code', 'plantillas.fieldTypecode'),
            new ItiVHeader('description', 'plantillas.fieldDescription').withWidth(300),
            new ItiVHeader('action', '').withWidth(50),
        ];
    }

    public get editTemplate() {
        if (!templatesModule.selectedTemplate.offer) templatesModule.selectedTemplate.offer = false;
        if (!templatesModule.selectedTemplate.demand) templatesModule.selectedTemplate.demand = false;
        return templatesModule.selectedTemplate;
    }

    public get categories() {
        return templatesModule.formattedCategoriesList;
    }

    public get fields() {
        return templatesModule.templateFields;
    }

    public get templateEditMode() {
        return templatesModule.templateEditMode;
    }

    public get templateTitle() {
        if (templatesModule.selectedTemplate.title == null || templatesModule.selectedTemplate.title.length == 0) {
            return this.$t('plantillas.nuevaPlantilla');
        } else {
            return templatesModule.selectedTemplate.title;
        }
    }

    public get hasPermission() {
        return itiPermissionService.hasPermission(Permission.updateTemplates);
    }

    public created() {
        if (!isNaN(this.id) && this.id != 0) {
            templatesModule.getTemplateById(this.id).then(() => {
                this.assignCategoryDescriptionsToLabel();
                this.assignOfferOrDemandToLabel();
                this.beforeTreeBoxValue = this.treeBoxValue;
            });
            templatesModule.setTemplateEditMode(true);
        }
    }

    public mounted() {
        templatesModule.getFormattedCategories();
    }

    public async saveTemplate() {
        itiMessageService.confirm(this.$tc('mensajes-plantillas.pregunta-guardar'), this.$tc('mensajes.confirmar'), (res) => {
            if (res) {
                if (!this.editTemplate.offer && !this.editTemplate.demand) {
                    itiMessageService.toast(this.$tc('mensajes-plantillas.info-error-oferta-demanda'), 'error', 2000);
                    return;
                }
                this.assignCategoryToTemplate();
                this.assignOfferOrDemandToLabel();
                templatesModule.saveTemplate(this.editTemplate)
                    .then(async () => {
                        await templatesModule.getTemplateById(this.editTemplate.id);
                        this.assignCategoryDescriptionsToLabel();
                        if (this.id == 0) this.$router.push({ name: 'PlantillaFormulario', params: { id: templatesModule.selectedTemplate.id.toString() } });
                        templatesModule.setTemplateEditMode(true);
                        itiMessageService.toast(this.$tc('mensajes-plantillas.ok'), 'success', 3000);
                        this.$router.push({ name: 'ListaPlantillas' });
                    })
                    .catch((err) => {
                        itiMessageService.toast(this.$tc('mensajes-plantillas.info-error'), 'error', 2000);
                    });
            }

        });
    }

    public cancelTemplate() {
        itiMessageService.confirm(this.$tc('mensajes-plantillas.pregunta-salir'), this.$tc('mensajes.confirmar'), (res) => {
            if (res) {
                // if (this.editTemplate.version != null) {
                templatesModule.getTemplateById(templatesModule.selectedTemplate.id);
                this.treeBoxValue = this.beforeTreeBoxValue;
                this.$router.push({ name: 'ListaPlantillas' });
                // } else {
                //     this.$router.push({ name: 'ListaPlantillas' });
                // }
            }
        });
    }

    public assignCategoryToTemplate() {
        if (!this.editTemplate.categories) {
            this.editTemplate.categories = new Categories();
            this.editTemplate.categories.id = 0;
        }

        switch (this.selectedCategory.level) {
            case 1: {
                this.editTemplate.categories.categoryFirstLevelId = this.selectedCategory.id;
                this.editTemplate.categories.categorySecondLevelId = 0;
                this.editTemplate.categories.categoryThirdLevelId = 0;
                this.editTemplate.categories.categoryFourthLevelId = 0;
                break;
            }
            case 2: {
                this.editTemplate.categories.categorySecondLevelId = this.selectedCategory.id;
                this.editTemplate.categories.categoryThirdLevelId = 0;
                this.editTemplate.categories.categoryFourthLevelId = 0;
                break;
            }
            case 3: {
                this.editTemplate.categories.categoryThirdLevelId = this.selectedCategory.id;
                this.editTemplate.categories.categoryFourthLevelId = 0;
                break;
            }
            case 4: {
                this.editTemplate.categories.categoryFourthLevelId = this.selectedCategory.id;
                break;
            }
        }
    }

    public async assignOfferOrDemandToLabel() {
        this.offerOrDemand = "";
        if (this.editTemplate.offer) {
            this.offerOrDemand = this.$tc('plantillas.oferta');
            if (this.editTemplate.demand) {
                this.offerOrDemand = this.offerOrDemand + ", " + this.$tc('plantillas.demanda');
            }
        } else if (this.editTemplate.demand) {
            this.offerOrDemand = this.$tc('plantillas.demanda');
        }
    }
    public async assignCategoryDescriptionsToLabel() {
        if (this.editTemplate.categories.categoryFourthLevelId != null) {
            this.categoriesDescription = this.editTemplate.categories.categoryFirstLevelDescription + " - " + this.editTemplate.categories.categorySecondLevelDescription + " - "
                + this.editTemplate.categories.categoryThirdLevelDescription + " - " + this.editTemplate.categories.categoryFourthLevelDescription;
            this.treeBoxValue = "4_" + this.editTemplate.categories.categoryFourthLevelId;
        } else if (this.editTemplate.categories.categoryThirdLevelId != null) {
            this.categoriesDescription = this.editTemplate.categories.categoryFirstLevelDescription + " - " + this.editTemplate.categories.categorySecondLevelDescription + " - "
                + this.editTemplate.categories.categoryThirdLevelDescription;
            this.treeBoxValue = "3_" + this.editTemplate.categories.categoryThirdLevelId;
        } else if (this.editTemplate.categories.categorySecondLevelId != null) {
            this.categoriesDescription = this.editTemplate.categories.categoryFirstLevelDescription + " - " + this.editTemplate.categories.categorySecondLevelDescription;
            this.treeBoxValue = "2_" + this.editTemplate.categories.categorySecondLevelId;
        } else if (this.editTemplate.categories.categoryFirstLevelId != null) {
            this.categoriesDescription = this.editTemplate.categories.categoryFirstLevelDescription;
            this.treeBoxValue = "1_" + this.editTemplate.categories.categoryFirstLevelId;
        }
        this.showSelectedCategoryExpanded();
    }

    public editTemplateParams() {
        templatesModule.getTemplateById(templatesModule.selectedTemplate.id);
        templatesModule.setTemplateEditMode(false);
        this.beforeTreeBoxValue = this.treeBoxValue;
    }

    // public async createNewField() {
    //     templatesModule.newField();
    //     if ((!isNaN(templatesModule.selectedTemplate.id) && templatesModule.selectedTemplate.id != 0)) {
    //         this.$router.push({ name: 'NuevoCampoFormulario', params: { idTemplate: templatesModule.selectedTemplate.id.toString(), idField: '0' } });
    //     } else {
    //         this.$router.push({ name: 'NuevoCampoFormulario', params: { idTemplate: '0', idField: '0' } });
    //     }
    // }

    // public deleteField(field: Field) {
    //     itiMessageService.confirm(this.$tc('mensajes-plantillas.pregunta-borrar-campo'), this.$tc('mensajes.confirmar'), (res) => {
    //         if (res) {
    //             templatesModule.deleteFieldFromTemplate(field);
    //             templatesModule.getValuesByFieldId(field.id) //Eliminar cada uno de los valores de ListValours
    //                 .then(() => {
    //                     templatesModule.values.forEach(element => {
    //                         templatesModule.deleteValues(element);
    //                     });
    //                 });
    //             templatesModule.saveTemplate(this.editTemplate)
    //                 .then(() => {
    //                     itiMessageService.toast(this.$tc('mensajes-plantillas.info-eliminar'), 'success', 3000);
    //                 })
    //                 .catch(() => {
    //                     itiMessageService.toast(this.$tc('mensajes-plantillas.info-error'), 'error', 2000);
    //                 });
    //         }
    //     });
    // }

    // public editFieldParams(field: Field) {
    //     templatesModule.setFieldToEdit(field);
    //     if (field.id) {
    //         this.$router.push({ name: 'NuevoCampoFormulario', params: { idTemplate: templatesModule.selectedTemplate.id.toString(), idField: field.id.toString() } });
    //     } else {
    //         this.$router.push({ name: 'NuevoCampoFormulario' });
    //     }
    // }

    public formattedContent(contenido: string) {
        if (contenido && contenido.length > 40) {
            return String(contenido).substring(0, 40) + "...";
        } else {
            return contenido;
        }
    }

    public treeView_itemSelectionChanged(e: any) {
        this.treeBoxValue = e.component.getSelectedNodeKeys();
    }

    public onTreeItemClick(e: any) {
        this.selectedCategory = e.itemData;
    }

    public showSelectedCategoryExpanded() {
        this.categories.forEach(element => {
            if (element.categoryId == this.treeBoxValue) {
                element.expanded = true;
                return;
            }
        });
    }

    public translateState(active: boolean) {
        return this.$tc(active.toString());

    }

}